export default __webpack_public_path__ + "static/media/certificate.6e9dd568.png";